export default {
  menu: {
    disk: 'My Net Disk',
    folder: 'Folder Management',
    log: 'Operation Log',
    dashboard: 'Dashboard',
    department: 'Dept. Management',
    role: 'Role Management',
    user: 'User Management',
    down: 'Download Track',
    roleAdd: 'Create Role',
  },
  button: {
    update: 'Edit',
    edit: 'Edit',
    delete: 'Delete',
    downLoad: 'Download',
    share: 'Share',
    preview: 'Preview',
    action: 'Operation',
    search: 'Search',
    reset: 'Reset',
    add: 'Create',
    cancel: 'Cancel',
    confirm: 'Confirm',
    export: 'Export',
    back: 'Back',
    close: 'Next',
    save: 'Save',
    deleteConfirm: 'Confirm Delete',
    abled: 'Enable',
    disabled: 'Disable',
    uploadFiles: 'Upload Files',
    downloadFiles: 'Download Files',
    addFolder: 'Create Folder',
    copy: 'Copy',
    move: 'Move',
    show: 'UnHide',
    hide: 'Hide',
    backBefore: 'Go Back',
    clickToUpload: 'Click to Upload',
    shutDown: 'Close',
    leaveConfirm: 'Confirm Leave',
    logout: 'Logout',
    more: 'More',
    upGo: 'Fold up',
  },
  common: {
    pleaseInput: 'Please input ',
    pleaseWrite: 'Please fill in ',
    pleaseSelect: 'Please select ',
    pleaseTickFar: 'Please check the agreement',
    whole: 'All',
    searchRegion: 'regionEn',
    selPleaseDepart: 'Please select',
    noData: 'No Data',
    uploadDrag: 'Drop file here or',
    uploadClick: 'Click to upload',
    iHaveReadAndAgree: 'I have read and agree',
    userUseAgreement: 'User Privacy Policy',
    platformUsageProtocol: 'Platform Usage Protocol',
    dealerHandbook: 'Dealer Handbook',
    pleaseSelectWiw: 'Please enter the complete wiw',
    410: 'Your account has expired and you will be redirected to the auth page...',
    401: 'You do not have access to this system',
  },
  table: {
    department: {
      name: 'Department Name',
      attribute: 'Department Attribute',
      localName: 'Root Folder Name',
      lastEditUser: 'Last Edited By',
      lastEditTime: 'Last Edited Time',
      createdUser: 'Creator',
      createdTime: 'Creation Time',
      description: 'Description',
    },
    user: {
      userId: 'User Id',
      name: 'Name',
      departAndDelear: 'Subordinate Business Department/Dealer Name',
      departAndRole: 'Department/Role',
      status: 'User Status',
      department: 'Department',
      role: 'Role',
      businessDepartment: 'Business Department',
      delaerCode: 'Dealer Code',
      delaerName: 'Dealer Name',
      delaerType: 'User Type',
      region: 'Region',
      north: 'North',
      south: 'South',
      east: 'East',
      west: 'West',
      post: 'Position',
    },
    role: {
      name: 'Role Name',
      description: 'Role Description',
      allRole: 'ALL Permissions',
      roleProperties: 'Role Attributes',
      menupermissions: 'Menu Permissions',
    },
    file: {
      roleChecked: 'Whether to set user permissions',
      folderStructure: 'Folder Structure',
      user: 'Users',
      permissionSettings: 'Permission Settings',
    },
    log: {
      id: 'Operator ID',
      act: 'Operation',
      actTime: 'Operation time',
      logContent: 'Log content',
      startTime: 'Start Time',
      endTime: 'End Time',
      dealerBusinessDepartment: 'Dealer/Business Department',
      exportTip:
        'The system supports exporting a maximum of 100,000 records. Please adjust the export time range to ensure the export of all data',
    },
    disk: {
      name: 'Name',
      fileExpirationTime: 'File Expiration Time',
      route: 'Path',
      files: 'Folder/File',
      filesShare: 'File Sharing',
      linkExpirationTime: 'Link Expiration Time',
      linkExpirationTimeT: 'Link Invalid Time',
      shareUsers: 'Sharing User',
      generateLink: 'Create Link',
      allDocuments: 'All Files',
      successfullyAdded: 'Successfully Added',
      fail: 'Failure',
      theIDAccountIncorrect: 'Invalid Account ID',
      noFolder: 'No Foldedr',
      fileExpirationTip: '指平台定期清理1年保存期机制，不代表文件版权使用期限。',
    },
    dashboard: {
      fileSave: 'File Storage',
      fileRelated: 'File Related',
      fileAccount: 'Total Number of Files',
      folderAccount: 'Total Numer of Folders',
      nearExpirationFiles: 'Files Near Expiration',
      userAccount: 'Number of Users',
      onlineYesterday: 'Online Yesterday',
      totalUsers: 'Total Number of Users',
      usedSpace: 'Used Space',
    },
    dashboardTap: {
      fileStatistics: 'File Statistics',
      dealerDownloads: 'Dealer Download Statistics',
      dealerUploadVolume: 'Dealer Upload Statistics',
      fileAddition: 'File Additions',
      folderAddition: 'Folder Additions',
      numberOfDownloadsOfFiles: 'Number of File Downloads',
      onlineUserVolume: 'Number of Online Users',
      month: 'Monthly',
      week: 'Weekly',
      downloadTime: 'Download Time',
      uploadTime: 'Upload Time',
      file: 'File',
      folder: 'Folder',
      department: 'Department',
    },
  },
  dialog: {
    departmentAdd: 'Create Department',
    departmentEdit: 'Edit Department',
    delaerStatus: 'Enable User',
    delaerDisabled: 'Disable User',
    deleteDepartment: 'Delete Department',
    deleteRole: 'Delete Role',
    roleAdd: 'Create Role',
    roleEdit: 'Edit Role',
    userEdit: 'Edit User',
    dealer: 'Dealer',
    internalUsers: 'Internal Users',
    enUsed:
      "After disabling a user, the user's department/role will be cleared.Are you confirm disable?",
    disabledTitle: 'Confirmation Tips',
    secondenUsed: 'Are you confirm disable?',
    deleteFolder: 'Delete Folder',
    deleteFile: 'Delete File',
    folderAdd: 'Create Folder',
    folderEdit: 'Modify Folder',
    copyTo: 'Copy To',
    moveTo: 'Move To',
    muchDelete: 'Batch Remove',
    content: {
      fileOne:
        'Supported file types include: pdf、wav、mov、mp4、wmv、mp3、jpg 、jpeg、png 、gif、zip、rar、7z、doc、docx、xlsx、xls、pptx、ppt、mpg、ai、psd、tif.',
      fileTwo: 'The maximum file size is 4GB.',
      fileThree: 'File Expiration Date: One Year',
      expireNotice: 'Exipired files will be cleared,please backup in time.',
    },
    upload: {
      noData: 'You have not uploaded any files yet.',
    },
  },
  confirm: {
    isConfirm: 'Are you sure to delete',
    department: 'Department',
    role: 'Role',
    isCDeleteFolder: 'Are you sure to delete selected folder?',
    isCDeleteFile: 'Are you sure to delete selected file',
    destinationFolder: 'Target Folder',
    moveExpireTime: 'Moving files, expired time not recalculated.',
    copyExpireTime: 'File expiration time:',
    copyExpireTimeTwo: 'Expired files will be cleaned up, please backup in time.',
    deleteMuchFile: 'Are you sure to delete selected folder/file?',
    deleteFileBeing: 'Are you sure to delete the file being uploaded?',
    leaveFileBeing:
      'The file being uploaded will terminate if left. Are you sure to leave this page?',
  },
  message: {
    del: 'Deleted successfully!',
    add: 'Created successfully!',
    update: 'Updated successfully!',
    delError: 'Delete failed!',
    updateError: 'Update failed!',
    addError: 'Create failed!',
    use: 'User enabled successfully!',
    disabledUse: 'User disabled successfully!',
    saveSuccessful: 'Save successfully!',
    saveError: 'Save failed!',
    saveError_s3: 'Save failed (S3)!',
    emptyFile: 'The folder cannot be empty',
    emptyPermisson: 'Function permission cannot be empty',
    emptyUsers: 'User cannot be empty',
    hideM: 'Only files can be hidden, folders do not have the hide operation!',
    showM: 'Only hidden files can be displayed, folders do not have teh display hidden operation!',
    showSuccess: 'Display Successful!',
    hideSuccess: 'Hide Successful!',
    copySuccess: 'Copy Successful!',
    moveSuccess: 'Move Successful!',
    shareUrlCopySuccess: 'The sharing link has been copied and can be pasted directly!',
    noContentFound: 'No Content Found',
    suspend: 'Pause',
    failedToUploadShards: 'Upload Chunk Failed',
    uploadSuccessful: 'Upload Successful',
    mergeShardingFailed: 'Merge Chunks Failed',
    failedToEstablishConnection: 'Failed to establish connection with the bucket',
    startBatchEndtime: 'Start time greater than end time',
    noRole: 'You do not have access to this system',
    pleaseUserWrite: 'Please fill in the sharing user',
    noFileSize: 'Limit uploading files exceeding 4G!',
    noUploadBefore: 'Restrict uploading of ',
    noUploadType: 'types of files',
    roleNoJoyes:
      'This role currently does not have menu permission configuration. Please choose another one',
    dashboardNotice: 'Statistics include folders/files logically deleted',
  },
}
